import {useEffect} from "react"
import {MDBBreadcrumb, MDBBreadcrumbItem, MDBCol, MDBRow} from "mdbreact"

import CustomerGrid from "../../components/Customer/CustomerGrid/index"
import AddEditCustomer from "../../components/Customer/AddEditCustomer/index"
import {RootState} from "../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../store"
import {fetchCustomers, setCustomerSearchText} from "./customerSlice"

import {Form, FormElement, Field, FormRenderProps} from "@progress/kendo-react-form"
import {Input} from "@progress/kendo-react-inputs"
import {Button} from "@progress/kendo-react-buttons"

const CustomersByRegion = () => {
    const dispatch = useAppDispatch()
    const searchText = useAppSelector((state: RootState) => state.containers.customer.customerSearchText)

    useEffect(() => {}, [dispatch])

    const changeHandler = (e: any) => dispatch(setCustomerSearchText(e.value))

    const searchHandler = () => {
        if (searchText.length >= 3) dispatch(fetchCustomers(searchText))
        return false
    }

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem> Settings </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Customers</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            {
                <>
                    <Form
                        onSubmit={searchHandler}
                        initialValues={{customerSearch: searchText}}
                        render={(formRenderProps: FormRenderProps) => (
                            <div
                                className="mb-2"
                                // style={{
                                //     display: "flex",
                                //     justifyContent: "flex-start",
                                //     alignItems: "end",
                                // }}
                            >
                                <MDBRow className="align-items-end">
                                    <MDBCol md="2" sm="3">
                                        <FormElement style={{maxWidth: 400}}>
                                            <fieldset className={"k-form-fieldset"}>
                                                <Field
                                                    onChange={changeHandler}
                                                    name={"customerSearch"}
                                                    component={Input}
                                                    label={"Search customer"}
                                                />
                                            </fieldset>
                                        </FormElement>
                                    </MDBCol>
                                    <MDBCol>
                                        <div className="k-form-buttons mt-auto">
                                            <Button
                                                type="submit"
                                                fillMode="flat"
                                                themeColor={"primary"}
                                                disabled={!formRenderProps.allowSubmit}
                                                onClick={formRenderProps.onSubmit}
                                            >
                                                GO
                                            </Button>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                        )}
                    />
                    <div>
                        <CustomerGrid />
                        <AddEditCustomer />
                    </div>
                </>
            }
        </>
    )
}

export default CustomersByRegion
